import { render, staticRenderFns } from "./insureNoticesNew.vue?vue&type=template&id=6711c8ce&scoped=true&"
import script from "./insureNoticesNew.vue?vue&type=script&lang=js&"
export * from "./insureNoticesNew.vue?vue&type=script&lang=js&"
import style0 from "./insureNoticesNew.vue?vue&type=style&index=0&id=6711c8ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6711c8ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6711c8ce')) {
      api.createRecord('6711c8ce', component.options)
    } else {
      api.reload('6711c8ce', component.options)
    }
    module.hot.accept("./insureNoticesNew.vue?vue&type=template&id=6711c8ce&scoped=true&", function () {
      api.rerender('6711c8ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/insureNoticesNew.vue"
export default component.exports